import { render } from "./StoreItemCard.vue?vue&type=template&id=42f61706&scoped=true"
import script from "./StoreItemCard.vue?vue&type=script&lang=js"
export * from "./StoreItemCard.vue?vue&type=script&lang=js"

import "./StoreItemCard.vue?vue&type=style&index=0&id=42f61706&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f61706"]])

export default __exports__